__turbopack_context__.v({
  "avatar": "UserAvatar-module__yTxxJG__avatar",
  "details": "UserAvatar-module__yTxxJG__details",
  "icon": "UserAvatar-module__yTxxJG__icon",
  "profileButton": "UserAvatar-module__yTxxJG__profileButton",
  "profileRow": "UserAvatar-module__yTxxJG__profileRow",
});
